"use client";
import "./DateOptionsModal.css";

const DateOptionsModal = ({
  visible,
  onClose,
  onSelectOption,
  title = "Date & Time Customization",
  subtitle = "Select the best option that fit your event type",
  options,
  customStyles = {},
}) => {
  if (!visible) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-indicator"></div>
        </div>

        <h2 className="modal-title">{title}</h2>
        <p className="modal-subtitle">{subtitle}</p>

        <div className="modal-options-container">
          {options.map((option) => (
            <div
              key={option.id}
              className="modal-option"
              onClick={() => onSelectOption(option.id)}
            >
              <h3 className="modal-option-title">{option.title}</h3>
              <p className="modal-option-description">{option.description}</p>
            </div>
          ))}
        </div>

        <button className="modal-close-button" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  );
};

export default DateOptionsModal;
